import type { ReactElement } from 'react';
import { THEME_PREFERENCES } from '@mcikm-vote/shared';
import type { ThemePreference } from '@mcikm-vote/shared';

import { useTheme } from '../theme/ThemeProvider';
import { Knopf } from './Knopf';

const BESCHRIFTUNGEN: Record<ThemePreference, string> = {
  system: 'System',
  light: 'Hell',
  dark: 'Dunkel',
};

/**
 * Umschaltung des Erscheinungsbilds (§21).
 *
 * Die Auswahl wird zusätzlich zur Farbe durch Beschriftung und `aria-pressed` vermittelt — die
 * Information ist damit nicht ausschließlich farbbasiert (§21).
 */
export function ThemeToggle(): ReactElement {
  const { preference, setPreference } = useTheme();

  return (
    <fieldset className="border-rand rounded-lg border p-2">
      <legend className="text-text-gedaempft px-1 text-sm">Erscheinungsbild</legend>
      <div className="flex gap-1" role="group">
        {THEME_PREFERENCES.map((wert) => {
          const aktiv = preference === wert;
          return (
            <Knopf
              key={wert}
              art={aktiv ? 'primaer' : 'sekundaer'}
              className="px-3 text-sm"
              aria-pressed={aktiv}
              onClick={() => {
                setPreference(wert);
              }}
            >
              {aktiv ? `✓ ${BESCHRIFTUNGEN[wert]}` : BESCHRIFTUNGEN[wert]}
            </Knopf>
          );
        })}
      </div>
    </fieldset>
  );
}
